module.exports = __webpack_public_path__ + "static/media/A16.6e92f098.jpg";